module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai288-1f75d956be50941c5205f8f35e6a1c96.jpg";